import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UserPlus, ExternalLink, ArrowDown, HandHeart, Users, BookOpen, CheckCircle2 } from 'lucide-react';
const FORM_EMBED_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfE4bMnfauBmkBHMs207OqYdThL7rF2mVZHPn8RUgCH0BWDWA/viewform?embedded=true';
const FORM_DIRECT_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSfE4bMnfauBmkBHMs207OqYdThL7rF2mVZHPn8RUgCH0BWDWA/viewform?usp=header';
const benefits = [{
  icon: <HandHeart className="w-6 h-6" data-id="element-496" data-mp="262jvpc3i6f44" />,
  title: 'Stand in the Gap',
  description: 'Join our monthly night watches and prayer meetings, interceding for our nation and the body of Christ.'
}, {
  icon: <Users className="w-6 h-6" data-id="element-497" data-mp="2evdcxf2ifokm" />,
  title: 'Serve on the Field',
  description: 'Take part in our hospital, orphanage, market, village, and correctional centre outreaches through the year.'
}, {
  icon: <BookOpen className="w-6 h-6" data-id="element-498" data-mp="2oucn522xbs9q" />,
  title: 'Grow in the Word',
  description: 'Be equipped through the study of God’s word, conferences, and retreats that raise Kingdom Giants.'
}];
export function JoinPage() {
  const [formLoaded, setFormLoaded] = useState(false);
  return <main className="flex-grow bg-ivory text-midnight pt-24" data-id="element-499" data-mp="yky44yzwuhrm">
      {/* Header */}
      <section className="bg-midnight text-ivory py-24 text-center relative overflow-hidden" data-id="element-500" data-mp="tld7iv87qli2">
        <div className="absolute top-0 right-0 w-1/2 h-full bg-midnight-light opacity-40 pointer-events-none" data-id="element-501" data-mp="1qbm1s12dl50j" />
        <div className="relative z-10 px-6 max-w-4xl mx-auto" data-id="element-502" data-mp="1m98yrkf0jl7g">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-503" data-mp="1hism42j0o3m5">
            <UserPlus className="w-4 h-4" data-id="element-504" data-mp="257lb1f181b79" />
            Membership
          </motion.div>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.05
        }} className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-6 leading-[0.95]" data-id="element-505" data-mp="2o5n2xjzhdvgs">
            Join the{' '}
            <span className="font-serif italic font-medium text-gold" data-id="element-506" data-mp="25d2rzhjqmb19">
              Movement
            </span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-lg md:text-xl text-ivory/70 font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-507" data-mp="2ab48bups3w91">
            Whether you are new to Camp David or have walked with us for years,
            register below to be counted among the intercessors raising a global
            endtime army.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15
        }} className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-508" data-mp="1f5oicqts99i5">
            <a href="#register" className="group inline-flex items-center justify-center gap-2 bg-gold text-midnight px-8 py-4 rounded-full font-bold text-sm tracking-wide hover:bg-white transition-colors w-full sm:w-auto" data-id="element-509" data-mp="1xv4l7ksxxe1q">
              Register Now
              <ArrowDown className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" data-id="element-510" data-mp="hftgq7stscmb" />
            </a>
            <a href={FORM_DIRECT_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border-2 border-white/15 px-8 py-4 rounded-full font-bold text-sm tracking-wide hover:border-gold hover:text-gold transition-colors w-full sm:w-auto" data-id="element-511" data-mp="ci1sbnre38mv">
              Open Form in New Tab
              <ExternalLink className="w-4 h-4" data-id="element-512" data-mp="sw7usu2aydy7" />
            </a>
          </motion.div>
        </div>
      </section>

      {/* What membership means */}
      <section className="py-24 md:py-32" data-id="element-513" data-mp="3rb8v88tfl5j7">
        <div className="max-w-7xl mx-auto px-6" data-id="element-514" data-mp="6hi8pgbjk47">
          <div className="text-center mb-16" data-id="element-515" data-mp="7af8yph6v95">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight/5 rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-516" data-mp="55lob77y51qb">
              What to Expect
            </div>
            <h2 className="text-4xl md:text-6xl font-display font-bold tracking-tighter" data-id="element-517" data-mp="38nca79vkvk3i">
              Life at{' '}
              <span className="font-serif italic font-medium text-gold" data-id="element-518" data-mp="3dl5ic8gfyo6f">
                Camp David
              </span>
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-519" data-mp="3601w7o6ti3od">
            {benefits.map((benefit, idx) => <motion.div key={benefit.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: idx * 0.1
          }} className="bg-white p-8 md:p-10 rounded-[2rem] border-2 border-midnight/5 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300" data-id="element-520" data-mp="311gvlnnnlhze" data-mpi={idx}>
                <div className="w-14 h-14 bg-gold rounded-full flex items-center justify-center mb-8 text-midnight shadow-lg" data-id="element-521" data-mp="23ernqx69sb5m">
                  {benefit.icon}
                </div>
                <h3 className="text-2xl font-display font-bold mb-4 leading-tight" data-id="element-522" data-mp="1oraqpeyv1q6b">
                  {benefit.title}
                </h3>
                <p className="text-charcoal/70 font-medium leading-relaxed" data-id="element-523" data-mp="1fs5syav4i0v7">
                  {benefit.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Registration form */}
      <section id="register" className="pb-24 md:pb-32 scroll-mt-28" aria-labelledby="register-heading" data-id="element-524" data-mp="28i4kqe0pcc3k">
        <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-525" data-mp="2ck9f5eyz5cr9">
          <div className="text-center mb-12" data-id="element-526" data-mp="1yq8n142j2nzv">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/20 text-midnight rounded-full text-xs font-bold tracking-widest uppercase mb-6" data-id="element-527" data-mp="23q4sl7qvinhj">
              <UserPlus className="w-4 h-4" data-id="element-528" data-mp="2re4hs38je5u0" />
              Registration
            </div>
            <h2 id="register-heading" className="text-4xl md:text-6xl font-display font-bold tracking-tighter mb-6" data-id="element-529" data-mp="2w77egk8m1vef">
              Register to{' '}
              <span className="font-serif italic font-medium text-gold" data-id="element-530" data-mp="31ikx8vi3tkxa">
                Join
              </span>
            </h2>
            <p className="text-base md:text-lg text-charcoal/70 font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-531" data-mp="3fa95uot59r9i">
              Fill in the form below. If it does not load, or you would rather
              complete it in your browser, use the direct link underneath.
            </p>
          </div>

          {/* Embedded Google Form */}
          <div className="bg-white p-3 sm:p-5 rounded-[2rem] border-2 border-midnight/5 shadow-xl" data-id="element-532" data-mp="2wk9nekrt7af2">
            <div className="relative rounded-[1.25rem] overflow-hidden bg-midnight/5" data-id="element-533" data-mp="2rlpxk9a3hehf">
              {!formLoaded && <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 py-24" data-id="element-534" data-mp="btiwq129my3l">
                  <div className="w-8 h-8 border-2 border-gold/30 border-t-gold rounded-full animate-spin" data-id="element-535" data-mp="6u60ippi8eoc" />
                  <p className="text-sm font-bold tracking-widest uppercase text-charcoal/50" data-id="element-536" data-mp="21cqujw9kb021">
                    Loading form…
                  </p>
                </div>}
              <iframe src={FORM_EMBED_URL} title="Camp David Prayer Platform membership registration form" loading="lazy" onLoad={() => setFormLoaded(true)} className={`w-full h-[1553px] block border-0 transition-opacity duration-500 ${formLoaded ? 'opacity-100' : 'opacity-0'}`} data-id="element-537" data-mp="2ab2uwq08dc7o">
                Loading…
              </iframe>
            </div>
          </div>

          {/* Alternative route */}
          <div className="mt-10 bg-midnight text-ivory p-8 md:p-10 rounded-[2rem] text-center" data-id="element-538" data-mp="2y1yjzfdaxtb8">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-6 text-gold" data-id="element-539" data-mp="ypdzkv72lwjb">
              <CheckCircle2 className="w-4 h-4" data-id="element-540" data-mp="13pigunfsyval" />
              Alternative
            </div>
            <h3 className="text-2xl md:text-3xl font-display font-bold tracking-tight mb-4" data-id="element-541" data-mp="w697uvb7kym2">
              Prefer to register directly?
            </h3>
            <p className="text-ivory/70 font-medium leading-relaxed max-w-xl mx-auto mb-8" data-id="element-542" data-mp="mdl8bssuggjn">
              Open the registration form in its own tab — often the easier route
              on a phone.
            </p>
            <a href={FORM_DIRECT_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-gold text-midnight px-8 py-4 rounded-full font-bold text-sm tracking-wide hover:bg-white transition-colors" data-id="element-543" data-mp="1f1pkmx5x7rvb">
              Open Registration Form
              <ExternalLink className="w-4 h-4" data-id="element-544" data-mp="3putrcfzb5mfy" />
            </a>
          </div>

          {/* Closing note */}
          <div className="mt-20 text-center" data-id="element-545" data-mp="3lsypnadgt71n">
            <p className="font-serif italic text-2xl md:text-3xl text-midnight leading-relaxed" data-id="element-546" data-mp="3ls6svw84t39s">
              "And I sought for a man among them, that should make up the
              hedge, and stand in the gap before me."
            </p>
            <p className="mt-3 text-sm tracking-widest uppercase text-charcoal/60 font-bold" data-id="element-547" data-mp="p80qf4v0f9tr">
              Ezekiel 22:30
            </p>
          </div>
        </div>
      </section>
    </main>;
}